import { api } from '../../Controllers/api'

const requestDispatches = () => {
  return {
    type: 'REQUEST_DISPATCHES',
    loading: true
  }
}

const requestDriverDispatches = () => {
  return {
    type: 'REQUEST_DRIVER_DISPATCHES',
    loading: true
  }
}

const receiveDispatches = data => {
  return {
    type: 'RECEIVE_DISPATCHES',
    payload: { data },
    loading: false
  }
}

const receiveDriverDispatches = data => {
  return {
    type: 'RECEIVE_DRIVER_DISPATCHES',
    payload: { data },
    loading: false
  }
}

const createdDispatch = newDispatch => {
  return {
    type: 'CREATE_DISPATCH',
    payload: { newDispatch },
    loading: false
  }
}

const editedDispatch = (_id, data) => {
  return {
    type: 'EDIT_DISPATCH',
    payload: { dispatch: { _id, ...data } },
    loading: false
  }
}

const driverNotificationSent = () => {
  return {
    type: 'DRIVER_DISPATCH_NOTIFICATION_SENT',
    payload: {},
    loading: false
  }
}

const replacedDriver = () => {
  return {
    type: 'REPLACE_DRIVER',
    payload: {},
    loading: false
  }
}

const cancelledDriver = cancelledDriverId => {
  return {
    type: 'CANCEL_DRIVER_DISPATCH',
    payload: { cancelledDriverId },
    loading: false
  }
}

const cancelledDispatch = cancelledDispatchId => {
  return {
    type: 'CANCEL_DISPATCH',
    payload: { cancelledDispatchId },
    loading: false
  }
}

const getDispatches = isRefresh => {
  return dispatch => {
    if (!isRefresh) {
      dispatch(requestDispatches())
    }
    api.get(`dispatches`).then(({ data }) => {
      dispatch(receiveDispatches(data))
    })
  }
}

const getDriverDispatches = isRefresh => {
  return dispatch => {
    if (!isRefresh) {
      dispatch(requestDriverDispatches())
    }
    api.get(`dispatches/driverDispatches`).then(({ data }) => {
      dispatch(receiveDriverDispatches(data))
    })
  }
}

const createDispatch = body => {
  return dispatch => {
    api.post(`dispatches`, body).then(({ data }) => {
      dispatch(createdDispatch({ ...body, _id: data.insertedId, active: true, delete: false }))
      dispatch(getDriverDispatches(true))
    })
  }
}

const editDispatch = (_id, body) => {
  return dispatch => {
    api.put(`dispatch/${_id}`, body).then(({ data }) => {
      dispatch(editedDispatch(_id, { ...body, active: true, delete: false }))
    })
  }
}

const sendDriverNotification = dispatchId => {
  return dispatch => {
    api.post(`dispatches/driverNotification/${dispatchId}`).then(({ data }) => {
      dispatch(driverNotificationSent(data))
    })
  }
}

const replaceDriver = (oldDispatch, newDriver) => {
  return dispatch => {
    const body = { oldDispatch, newDriver }
    api.post(`dispatches/replaceDriver/`, body).then(({ data }) => {
      dispatch(replacedDriver(data))
      dispatch(getDriverDispatches(true))
    })
  }
}

const cancelDriver = dispatchDetails => {
  return dispatch => {
    const body = { ...dispatchDetails }
    api.post(`dispatches/cancelDriver`, body).then(({ data }) => {
      dispatch(cancelledDriver(dispatchDetails._id))
      dispatch(getDriverDispatches(true))
    })
  }
}

const cancelDispatch = dispatchDetails => {
  return dispatch => {
    const body = { ...dispatchDetails }
    api.post(`dispatches/cancelDispatch`, body).then(({ data }) => {
      // dispatch(cancelledDispatch(dispatchDetails._id))
      dispatch(getDispatches(true))
      dispatch(getDriverDispatches(true))
    })
  }
}

export {
  getDispatches,
  createDispatch,
  editDispatch,
  getDriverDispatches,
  sendDriverNotification,
  replaceDriver,
  cancelDriver,
  cancelDispatch
}
